<template>
  <div>
    <vx-card class="p-10">
      <div class="text-center pb-2">
        <h4>Remainder Accounts</h4>
      </div>

      <div class="mb-5" style="float:right;">
        <vs-button class=" float-right" @click="finishUploadedAccount(table_name)" color="primary"
          type="filled">Complete</vs-button>
        <vs-button @click="rejectedAccounts" color="primary" type="filled" class="mr-5">Rejected Accounts</vs-button>
      </div>
      <div>
        <!-- AgGrid Table -->
        <DataGrid :context="''" @rejectRemainderAccounts="rejectRemainderAccounts" @acceptRemainderAccounts="acceptRemainderAccounts"
          ref="remainderAccountsGrid" :columnDefs="columnDefs" :rowData="remainderAccounts" :dataSource="dataSource">
        </DataGrid>
      </div>
      <vs-popup title="Please fill up the account details and click the submit button." :active.sync="popupActive"
        fullscreen>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span :class="{ 'correction_field_class': correction_fields_array.includes('enh_company_registration_number') }">Company
              Registration No.</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input :class="{ 'correction_field_input_class': correction_fields_array.includes('enh_company_registration_number') }"
              class="w-full" v-model="company_registration_number" name="company_registration_number"
              v-validate="'required'" data-vv-as="Company Registration Number" />
            <span class="text-danger text-sm" v-show="errors.has('company_registration_number')">{{
              errors.first("company_registration_number") }}</span>
          </div>


        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span
              :class="{ 'correction_field_class': correction_fields_array.includes('enh_registered_office_country') }">Registered
              Office
              Country</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">

            <AccountAutocomplete
              :class="{ 'correction_field_input_class': correction_fields_array.includes('enh_registered_office_country') }"
              :key="EnhancedRegOfficeAutocompleteComponentKey" ref="enhanceRegisteredOfficeCountryRef"
              :chosen="selected_registered_office_country" :list="getCountries" :searchOn="'registered_office_country'">
            </AccountAutocomplete>
            <p class="p-2" style="color:red;" v-if="registered_office_country_validation">
              {{ registered_office_country_validation }}
            </p>
          </div>
        </div>

        <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_company')">
          <div class="vx-col sm:w-1/3 w-full">
            <span :class="{ 'correction_field_class': correction_fields_array.includes('enh_company') }">Company
              Name</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input :class="{ 'correction_field_input_class': correction_fields_array.includes('enh_company') }"
              class="w-full" v-model="company_name" name="company_name" v-validate="'required'"
              data-vv-as="Company Name" />
            <span class="text-danger text-sm" v-show="errors.has('company_name')">{{
              errors.first("company_name") }}</span>
          </div>

        </div>

        <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_switchboard')">
        <div class="vx-col sm:w-1/3 w-full">
          <span
            :class="{ 'correction_field_class': correction_fields_array.includes('enh_switchboard_phone_code') }">Switchboard:</span>
        </div>
        
        <div class="vx-col sm:w-1/3 w-full">
          <div class="vx-row mb-6">

            <div class="vx-col sm:w-1/2 w-full">
              <v-select :class="{ 'correction_field_input_class': correction_fields_array.includes('enh_switchboard_phone_code') }" name="phone_code" label="name_with_code" :options="all_phone_codes"
                :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="switchboard_phone_code" />
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <vs-input type="number" class="w-full" v-model="switchboard" />
            </div>
          </div>

        </div>
      </div>
      <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_site_switchboard')">
        <div class="vx-col sm:w-1/3 w-full">
          <span
            :class="{ 'correction_field_class': correction_fields_array.includes('enh_site_switchboard_phone_code') }">site_switchboard:</span>
        </div>
        
        <div class="vx-col sm:w-1/3 w-full">
          <div class="vx-row mb-6">

            <div class="vx-col sm:w-1/2 w-full">
              <v-select :class="{ 'correction_field_input_class': correction_fields_array.includes('enh_site_switchboard_phone_code') }" name="phone_code" label="name_with_code" :options="all_phone_codes"
                :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="site_switchboard_phone_code" />
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <vs-input type="number" class="w-full" v-model="site_switchboard" />
            </div>
          </div>

        </div>
      </div>
        <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_status')">
          <div class="vx-col sm:w-1/3 w-full">
            <span :class="{ 'correction_field_class': correction_fields_array.includes('enh_status') }">Status</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input :class="{ 'correction_field_input_class': correction_fields_array.includes('enh_status') }"
              class="w-full" v-model="status" name="status" v-validate="'required'" data-vv-as="Status" />
            <span class="text-danger text-sm" v-show="errors.has('status')">{{
              errors.first("status") }}</span>
          </div>

        </div>
        <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_linkedin')">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Social Media</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="social_media" />
          </div>
        </div>
        <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_web')">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Website</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="website" />
          </div>
        </div>
        <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_phone')">
          <div class="vx-col sm:w-1/3 w-full">
            <span :class="{ 'correction_field_class': correction_fields_array.includes('enh_phone_type') }">Phone
              Number</span>
          </div>

          
          <div class="vx-col sm:w-1/5 w-full">
            <v-select name="phone_code" class="phone_code" label="name_with_code"
                                    :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="phone_code" />
          </div>
          <div class="vx-col sm:w-1/5 w-full">
            <vs-input class="w-full" v-model="phone_no" @input="phone_no = phone_no.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');" />
          </div>
          <div class="vx-col sm:w-1/4 w-full">
            <v-select :class="{ 'correction_field_input_class': correction_fields_array.includes('enh_phone_type') }"
              label="name" :options="phoneTypes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="phone_type" />
          </div>
        </div>
        <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_sic_code')">
          <div class="vx-col sm:w-1/3 w-full">
            <span :class="{ 'correction_field_class': correction_fields_array.includes('enh_sic_code') }">Sic Code</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <!-- <vs-input class="w-full" v-model="sic_code" /> -->
            <AccountAutocomplete
              :class="{ 'correction_field_input_class': correction_fields_array.includes('enh_sic_code') }"
              :key="EnhancedSicCodeAutocompleteComponentKey" ref="EnhanchedSicCodeRef" :chosen="selected_sic_code"
              :list="getSicCodes" :searchOn="'sic_codes'"></AccountAutocomplete>
          </div>
        </div>
        <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_registration_jurisdiction')">
          <div class="vx-col sm:w-1/3 w-full">
            <span
              :class="{ 'correction_field_class': correction_fields_array.includes('enh_registration_jurisdiction') }">Registration
              Jurisdiction:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <!-- <vs-input class="w-full" v-model="sic_code" /> -->
            <AccountAutocomplete
              :class="{ 'correction_field_input_class': correction_fields_array.includes('enh_registration_jurisdiction') }"
              :key="EnhancedRegistrationJurisdictionAutocompleteComponentKey" ref="EnhancedRegistrationJurisdictionRef"
              :chosen="selected_registration_jurisdiction" :list="getCountries" :searchOn="'registration_jurisdiction'">
            </AccountAutocomplete>
          </div>
        </div>
        <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_vertical')">
          <div class="vx-col sm:w-1/3 w-full">
            <span :class="{ 'correction_field_class': correction_fields_array.includes('enh_vertical') }">Vertical:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <!-- <vs-input class="w-full" v-model="sic_code" /> -->
            <AccountAutocomplete
              :class="{ 'correction_field_input_class': correction_fields_array.includes('enh_vertical') }"
              :key="EnhancedVerticalAutocompleteComponentKey" ref="EnhancedVerticalRef" :chosen="selected_vertical"
              :list="getVerticals" :searchOn="'vertical'"></AccountAutocomplete>
          </div>
        </div>

        <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_revenue')">
          <div class="vx-col sm:w-1/3 w-full">
            <span
              :class="{ 'correction_field_class': correction_fields_array.includes('enh_currency_code') }">Revenue:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/2 w-full">
                <v-select label="label"
                  :class="{ 'correction_field_input_class': correction_fields_array.includes('enh_currency_code') }"
                  :options="currencyCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="currency_code" />
              </div>

              <div class="vx-col sm:w-1/2 w-full">
                <vs-input class="w-full" v-model="revenue" />
              </div>
            </div>

          </div>
        </div>
        <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_no_of_employees')">
          <div class="vx-col sm:w-1/3 w-full">
            <span>No Of Employee</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="no_of_employees" />
          </div>
        </div>
        <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_company_category')">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Company Category</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="company_category" />
          </div>
        </div>
        <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_head_office_address_1')">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Head Office Address 1</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="head_office_address_1" name="head_office_address_1"
              data-vv-as="Head Office Address 1" />
          </div>

        </div>
        <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_head_office_address_2')">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Head Office Address 2</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="head_office_address_2" />
          </div>
        </div>
        <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_head_office_address_3')">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Head Office Address 3</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="head_office_address_3" />
          </div>
        </div>
        <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_head_office_city')">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Head Office City</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="head_office_city" name="head_office_city" data-vv-as="Head Office City" />
          </div>

        </div>
        <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_head_office_county')">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Head Office County</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="head_office_county" />
          </div>
        </div>
        <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_head_office_postcode')">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Head Office Postcode</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="head_office_postcode" />
          </div>
        </div>
        <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_head_office_country')">
          <div class="vx-col sm:w-1/3 w-full">
            <span :class="{ 'correction_field_class': correction_fields_array.includes('enh_head_office_country') }">Head
              Office Country</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <AccountAutocomplete
              :class="{ 'correction_field_input_class': correction_fields_array.includes('enh_head_office_country') }"
              :key="EnhancedHeadOfficeAutocompleteComponentKey" ref="enhanceHeadOfficeCountryRef"
              :chosen="selected_head_office_country" :list="getCountries" :searchOn="'head_office_country'">
            </AccountAutocomplete>
          </div>
        </div>
        <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_registered_office_address_1')">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Registered Office address 1</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="registered_office_address_1" />
          </div>
        </div>
        <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_registered_office_address_2')">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Registered Office address 2</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="registered_office_address_2" />
          </div>
        </div>
        <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_registered_office_address_3')">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Registered Office address 3</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="registered_office_address_3" />
          </div>
        </div>
        <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_registered_office_city')">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Registered Office city</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="registered_office_city" />
          </div>
        </div>
        <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_registered_office_county')">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Registered Office county</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="registered_office_county" />
          </div>
        </div>
        <div class="vx-row mb-6" v-if="field_array_columns.includes('enh_registered_office_postcode')">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Registered Office postcode</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="registered_office_postcode" />
          </div>
        </div>
        <!-- <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Is new account?</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-checkbox v-model="isNewAccount" vs-value="Y"></vs-checkbox>
        </div>
      </div> -->

        <div class="vx-row">
          <div class="vx-col sm:w-2/3 w-full ml-auto">
            <vs-button @click="submitUpdate()" class="mr-3 mb-2">Submit</vs-button>
          </div>
        </div>
      </vs-popup>
    </vx-card>
  </div>
</template>

<script>
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import axios from "@/axios.js";
import AccountAutocomplete from "@/components/autocomplete/AccountsAutocomplete.vue";
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import vSelect from "vue-select";
import _ from "lodash";
export default {
  components: {
    vSelect,
    AccountAutocomplete,
    DataGrid
  },
  watch: {
  },
  data() {
    return {
      phone_code : null,
      all_phone_codes: [],
      phoneTypes: [],
      selected_registered_office_country: null,
      correction_fields_array: [],
      vertical: null,
      selected_vertical: null,
      correction_fields: null,
      selected_registration_jurisdiction: null,
      currencyCodes: [],
      selected_sic_code: null,
      add_or_update_title: null,
      user_id: null,
      user_role: null,
      selected_head_office_country: null,
      abilities: null,
      field_array_columns: [],
      registered_office_address_1: null,
      registered_office_address_2: null,
      registered_office_address_3: null,
      registered_office_city: null,
      registered_office_county: null,
      registered_office_postcode: null,
      registered_office_country: null,
      head_office_address_1: null,
      head_office_address_2: null,
      head_office_address_3: null,
      head_office_city: null,
      head_office_county: null,
      head_office_postcode: null,
      company_category: null,
      sic_code: null,
      revenue: null,
      currency_code: null,
      registration_jurisdiction: null,
      no_of_employees: null,
      // sic_code_description: null,
      phone_type: null,
      phone_no: null,
      phone_code: null,
      website: null,
      social_media: null,
      status: null,
      switchboard: null,
      switchboard_phone_code: null,
      site_switchboard: null,
      site_switchboard_phone_code: null,
      company_name: null,
      selected_fields: [],
      registered_office_country_validation: null,
      EnhancedHeadOfficeAutocompleteComponentKey: 0,
      EnhancedRegOfficeAutocompleteComponentKey: 0,
      EnhancedSicCodeAutocompleteComponentKey: 0,
      EnhancedVerticalAutocompleteComponentKey: 0,
      EnhancedRegistrationJurisdictionAutocompleteComponentKey: 0,
      company_registration_number: null,
      country: null,
      isNewAccount: null,
      update_id: null,
      table: null,
      popupActive: false,
      updateData: [],
      validation_message: "",
      allSelected: false,
      selected: [],
      count: 0,
      showFieldComparision: false,
      tableData: [],
      header: [],
      sheetName: "",
      list2: [],
      uploaded_columns: [],
      accept_text: "Accept",
      acceptButtonColor: "primary",
      dataSource: {},
      remainderAccounts: [],
      columnDefs: [
        {
          headerName: "Actions",
          field: "transactions",
          cellRenderer: "CellRendererActions",
          suppressHeaderMenuButton: true,
          pinned: true,
          width: 90
        }
      ],
      popupActive: false,
      abilities: null,
      table_name: null
    };
  },
  methods: {
    getAllPhoneCodes() {
      let self = this
      this.$store
        .dispatch("accountsManagement/getAllPhoneCodes")
        .then(response => {
          self.all_phone_codes = response.data
          self.all_phone_codes.forEach(function (ele) {
            if (ele.phone_code) {
              ele.name_with_code = ele.phone_code + ' - ' + ele.name_1
            }
            return ele
          })
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getPhoneTypes() {
      this.$store
        .dispatch("accountsManagement/getPhoneTypes")
        .then(res => {
          this.phoneTypes = res.data;
          this.phoneTypes = this.phoneTypes.filter(
            item => item.name != "Site Switchboard"
          );
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getCurrencyCodes(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCurrencyCodes")
        .then(response => {
          let response_data = response.data
          let mappedArray = [];
          for (const property in response_data) {
            mappedArray.push({
              id: response_data[property].id,
              label: response_data[property].symbol + ' ' + response_data[property].name + ' ' + response_data[property].code
            });
          }
          this.currencyCodes = mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getCountries(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCountries", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.countries;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].name_1
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getSicCodes(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getSicCodes", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.sic_codes;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].code + ' - ' + data[property].description
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getVerticals(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getVerticals", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.verticals;
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].vertical
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    capitalizeTheFirstLetterOfEachWord(words) {
      var separateWord = words.toLowerCase().split(' ');
      for (var i = 0; i < separateWord.length; i++) {
        separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
          separateWord[i].substring(1);
      }
      return separateWord.join(' ');
    },
  
    getCountries(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCountries", inputValue)
        .then(response => {
          if (response) {
            let data = moduleAccountsManagement.state.countries;
            let mappedArray = [];
            for (const property in data) {
              mappedArray.push({
                id: data[property].id,
                name: data[property].name_1
              });
            }
            return mappedArray;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    submitUpdate() {


this.$validator.validateAll().then(result => {
  if (result) {




    if (moduleAccountsManagement.registered_office_country_selected != undefined) {
      this.registered_office_country = moduleAccountsManagement.registered_office_country_selected.name;
      if (this.registered_office_country == undefined) {
        this.registered_office_country = this.$refs.enhanceRegisteredOfficeCountryRef.$refs.suggestComponent.input.value
        this.registered_office_country = this.$refs.enhanceRegisteredOfficeCountryRef.$refs.suggestComponent.value
      }
    } else {
      this.registered_office_country = this.$refs.enhanceRegisteredOfficeCountryRef.$refs.suggestComponent.input.value
      this.registered_office_country = this.$refs.enhanceRegisteredOfficeCountryRef.$refs.suggestComponent.value
    }

    if (moduleAccountsManagement.head_office_country_selected != undefined) {
      this.head_office_country = moduleAccountsManagement.head_office_country_selected.name;
      if (this.head_office_country == undefined) {
        if (this.$refs.enhanceHeadOfficeCountryRef != undefined) {

          this.head_office_country = this.$refs.enhanceHeadOfficeCountryRef.$refs.suggestComponent.input.value
          this.head_office_country = this.$refs.enhanceHeadOfficeCountryRef.$refs.suggestComponent.value
        }
      }
    } else {
      if (this.$refs.enhanceHeadOfficeCountryRef != undefined) {

        this.head_office_country = this.$refs.enhanceHeadOfficeCountryRef.$refs.suggestComponent.input.value
        this.head_office_country = this.$refs.enhanceHeadOfficeCountryRef.$refs.suggestComponent.value
      }
    }


    if (moduleAccountsManagement.sic_codes_selected != undefined) {
      this.sic_code = moduleAccountsManagement.sic_codes_selected.name;
      if (this.sic_code == undefined) {
        if (this.$refs.EnhanchedSicCodeRef != undefined) {
          this.sic_code = this.$refs.EnhanchedSicCodeRef.$refs.suggestComponent.input.value
          this.sic_code = this.$refs.EnhanchedSicCodeRef.$refs.suggestComponent.value
        }
      }
    }
    else {
      if (this.$refs.EnhanchedSicCodeRef != undefined) {
        this.sic_code = this.$refs.EnhanchedSicCodeRef.$refs.suggestComponent.input.value
        this.sic_code = this.$refs.EnhanchedSicCodeRef.$refs.suggestComponent.value
      }
    }
    if (moduleAccountsManagement.countries_selected != undefined) {
      this.registration_jurisdiction = moduleAccountsManagement.countries_selected.name;
      if (this.registration_jurisdiction == undefined) {
        if (this.$refs.EnhancedRegistrationJurisdictionRef != undefined) {

          this.registration_jurisdiction = this.$refs.EnhancedRegistrationJurisdictionRef.$refs.suggestComponent.input.value
          this.registration_jurisdiction = this.$refs.EnhancedRegistrationJurisdictionRef.$refs.suggestComponent.value
        }
      }
    }

    else {
      if (this.$refs.EnhancedRegistrationJurisdictionRef != undefined) {

        this.registration_jurisdiction = this.$refs.EnhancedRegistrationJurisdictionRef.$refs.suggestComponent.input.value
        this.registration_jurisdiction = this.$refs.EnhancedRegistrationJurisdictionRef.$refs.suggestComponent.value
      }
    }
    if (moduleAccountsManagement.vertical_selected != undefined) {
      this.vertical = moduleAccountsManagement.vertical_selected.vertical;
      if (this.vertical == undefined) {
        if (this.$refs.EnhancedVerticalRef != undefined) {

          this.vertical = this.$refs.EnhancedVerticalRef.$refs.suggestComponent.input.value
          this.vertical = this.$refs.EnhancedVerticalRef.$refs.suggestComponent.value
        }
      }
    }

    else {
      if (this.$refs.EnhancedVerticalRef != undefined) {

        this.vertical = this.$refs.EnhancedVerticalRef.$refs.suggestComponent.input.value
        this.vertical = this.$refs.EnhancedVerticalRef.$refs.suggestComponent.value

      }

    }


    if (this.registered_office_country == '') {
      this.registered_office_country = null
    }

    if (this.registered_office_country == null) {
      this.registered_office_country_validation =
        "Registered Office Country is required.";
      return false;
    } else {
      this.registered_office_country_validation = null

    }

    let updateData = { fieldValues: {} };
    updateData.id = this.update_id;
    updateData.company_registration_number = this.company_registration_number;
    updateData.registered_office_country = this.registered_office_country;
    updateData.isNewAccount = this.isNewAccount;
    updateData.fields = this.selected_fields.toString();
    updateData.fieldValues.enh_company = this.company_name;
    updateData.fieldValues.enh_switchboard = this.switchboard;
    updateData.fieldValues.enh_switchboard_phone_code = this.switchboard_phone_code;
    updateData.fieldValues.enh_site_switchboard = this.site_switchboard;
    updateData.fieldValues.enh_site_switchboard_phone_code = this.site_switchboard_phone_code;
    updateData.fieldValues.enh_status = this.status;
    updateData.fieldValues.enh_social_media = this.social_media;
    updateData.fieldValues.enh_website = this.website;
    updateData.fieldValues.enh_phone_no = this.phone_no;
    updateData.fieldValues.enh_phone_code = this.phone_code;
    updateData.fieldValues.enh_phone_type = this.phone_type;
    updateData.fieldValues.enh_company_category = this.company_category;
    updateData.fieldValues.enh_head_office_address_1 = this.head_office_address_1;
    updateData.fieldValues.enh_head_office_address_2 = this.head_office_address_2;
    updateData.fieldValues.enh_head_office_address_3 = this.head_office_address_3;
    updateData.fieldValues.enh_head_office_city = this.head_office_city;
    updateData.fieldValues.enh_head_office_county = this.head_office_county;
    updateData.fieldValues.enh_head_office_country = this.head_office_country;
    updateData.fieldValues.enh_head_office_postcode = this.head_office_postcode;
    updateData.fieldValues.enh_registered_office_address_1 = this.registered_office_address_1;
    updateData.fieldValues.enh_registered_office_address_2 = this.registered_office_address_2;
    updateData.fieldValues.enh_registered_office_address_3 = this.registered_office_address_3;
    updateData.fieldValues.enh_registered_office_city = this.registered_office_city;
    updateData.fieldValues.enh_registered_office_county = this.registered_office_county;
    updateData.fieldValues.enh_registered_office_postcode = this.registered_office_postcode;
    updateData.fieldValues.enh_sic_code = this.sic_code;
    updateData.fieldValues.enh_vertical = this.vertical;
    updateData.fieldValues.enh_registration_jurisdiction = this.registration_jurisdiction;
    updateData.fieldValues.enh_revenue = this.revenue != null?this.revenue.replace(/,/g, ''):null
    updateData.fieldValues.enh_currency_code = this.currency_code;
    updateData.fieldValues.enh_no_of_employees = this.no_of_employees != null?this.no_of_employees.replace(/,/g, ''):null
    updateData.fieldValues.enh_sic_code = this.sic_code;
    updateData.fieldValues.enh_vertical = this.vertical;
    updateData.fieldValues.enh_head_office_country = this.head_office_country;
    updateData.fieldValues.enh_registration_jurisdiction = this.registration_jurisdiction;
    updateData.fieldValues.enh_currency_code = this.currency_code;
    updateData.table = this.table_name;
    axios
      .post(
        this.$base_url + "/api/enhanced_accounts/add_remainder_accounts_to_master_db",
        updateData
      )
      .then(response => {
        if (response.data.status == "success") {
          this.popupActive = false;
          if (moduleAccountsManagement.registered_office_country_selected != undefined) {
            moduleAccountsManagement.registered_office_country_selected = {}
          } else {
            this.$refs.enhanceRegisteredOfficeCountryRef.$refs.suggestComponent.input.value = {}
            this.$refs.enhanceRegisteredOfficeCountryRef.$refs.suggestComponent.value = {}
          }

          if (this.$refs.enhanceHeadOfficeCountryRef != undefined) {


            if (moduleAccountsManagement.head_office_country_selected != undefined) {
              moduleAccountsManagement.head_office_country_selected = {}
            } else {
              this.$refs.enhanceHeadOfficeCountryRef.$refs.suggestComponent.input.value = null
              this.$refs.enhanceHeadOfficeCountryRef.$refs.suggestComponent.value = null
            }
          }


          if (this.$refs.EnhanchedSicCodeRef != undefined) {

            if (moduleAccountsManagement.sic_codes_selected != undefined) {
              moduleAccountsManagement.sic_codes_selected = {}
            } else {
              this.sic_code = this.$refs.EnhanchedSicCodeRef.$refs.suggestComponent.input.value
              this.sic_code = this.$refs.EnhanchedSicCodeRef.$refs.suggestComponent.value
            }

          }






          if (this.$refs.EnhancedRegistrationJurisdictionRef != undefined) {

            if (moduleAccountsManagement.countries_selected != undefined) {
              moduleAccountsManagement.countries_selected = {}
            } else {
              this.$refs.EnhancedRegistrationJurisdictionRef.$refs.suggestComponent.input.value = null
              this.$refs.EnhancedRegistrationJurisdictionRef.$refs.suggestComponent.value = null
            }


          }


          if (this.$refs.EnhancedVerticalRef != undefined) {

            if (moduleAccountsManagement.vertical_selected != undefined) {
              moduleAccountsManagement.vertical_selected.vertical = {}
            } else {
              this.$refs.EnhancedVerticalRef.$refs.suggestComponent.input.value = null
              this.$refs.EnhancedVerticalRef.$refs.suggestComponent.value = {}
            }


          }



          this.registered_office_country_validation = null

          this.$refs.remainderAccountsGrid.gridApi.refreshServerSide({purge : true});
          this.getDataSource();



        }
        if (response.data.status == "completed") {
          this.popupActive = false;


        

                              location.reload();

        }
        if (response.data.status == "company_registration_number_exists") {
          this.popupActive = false;
          this.$vs.dialog({
            color: "primary",
            title: `Duplicate Company Registration Number`,
            text:
              "Company registration number already exists in the database.Please update it and submit again",
            accept: this.acceptAlert
          });
        }




          






      })
      .catch(error => {
        console.log(error);
      });
  }

})



},
    acceptAlert() {
      this.popupActive = true;
    },
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {
          params.request.table_name = self.table_name;
          // console.log(JSON.stringify(params.request, null, 1));
          self.$store
            .dispatch("accountsManagement/getRemainAccounts", params.request)
            .then(function (response) {
              let response_data = response.rows;
              if (response_data.length != 0) {


                
                self.$refs.remainderAccountsGrid.gridApi.hideOverlay();

                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.remainderAccountsGrid.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }


              
            })


         

            // .then(response =>
            //   params.successCallback(response.rows, response.lastRow)
            // )
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    finishUploadedAccount(table_name) {
      axios
        .post(
          this.$base_url + "/api/enhanced_accounts/finish_machine_learning_enhance",
          { table_name: table_name }
        )
        .then(response => {
          if (response.data.status == "success") {
            this.$vs.notify({
              color: "success",
              title: "Uploaded Account",
              text: "The uploaded account has been deleted successfully"
            });
          }
          this.$router.replace("/dashboard");
          this.$vs.loading.close();
        })
        .catch(error => {
          console.log(error);
        });
    },
    goBack: function () {
      this.$router.go(-1);
    },
    acceptRemainderAccounts(data) {
      console.log(data);



      this.head_office_country = null
      this.company_name = null
      this.switchboard = null
      this.switchboard_phone_code = null
      this.site_switchboard = null
      this.site_switchboard_phone_code = null
      this.status = null
      this.social_media = null
      this.website = null
      this.phone_no = null
      this.phone_type = null
      this.phone_code = null
      this.sic_code = null
      this.registration_jurisdiction = null
      this.no_of_employees = null
      this.revenue = null
      this.currency_code = null
      this.company_category = null
      this.head_office_address_1 = null
      this.head_office_address_2 = null
      this.head_office_address_3 = null
      this.head_office_city = null
      this.head_office_county = null
      this.head_office_postcode = null
      this.registered_office_address_1 = null
      this.registered_office_address_2 = null
      this.registered_office_address_3 = null
      this.registered_office_city = null
      this.registered_office_county = null
      this.registered_office_postcode = null
      this.registered_office_country = null
      this.isNewAccount = "Y";
      this.add_or_update_title = "Please update the field and submit"
      this.registered_office_country_validation = null;
      this.company_registration_number = data.enh_company_registration_number;
      this.company_name = data.enh_company;
      this.switchboard = data.enh_switchboard;
      this.switchboard_phone_code = data.enh_switchboard_phone_code
      this.site_switchboard = data.enh_site_switchboard;
      this.site_switchboard_phone_code = data.enh_site_switchboard_phone_code
      this.status = data.enh_status;
      this.social_media = data.enh_linkedin;
      this.website = data.enh_web;
      this.phone_no = data.enh_phone;
      this.phone_code = data.enh_phone_code;
      this.phone_type = data.enh_phone_type;
      this.vertical = data.enh_vertical;
      this.sic_code = data.enh_sic_code;
      this.registration_jurisdiction = data.enh_registration_jurisdiction;
      this.head_office_country = data.enh_head_office_country;
      this.registered_office_country = data.enh_registered_office_country
      if (this.registered_office_country != null) {
        // this.head_office_country = this.capitalizeTheFirstLetterOfEachWord(this.head_office_country)
        this.$refs.enhanceRegisteredOfficeCountryRef.$refs.suggestComponent.input.value = this.registered_office_country;
        this.$refs.enhanceRegisteredOfficeCountryRef.$refs.suggestComponent.value = this.registered_office_country;
      }
      if (moduleAccountsManagement.sic_codes_selected != undefined) {
        moduleAccountsManagement.sic_codes_selected = {}
      }
      if (this.$refs.EnhanchedSicCodeRef != undefined) {
        this.$refs.EnhanchedSicCodeRef.$refs.suggestComponent.input.value = this.sic_code
        this.$refs.EnhanchedSicCodeRef.$refs.suggestComponent.value = this.sic_code
      }

      if (moduleAccountsManagement.countries_selected != undefined) {
        moduleAccountsManagement.countries_selected = {}
      }
      if (this.$refs.EnhancedRegistrationJurisdictionRef != undefined) {
        this.$refs.EnhancedRegistrationJurisdictionRef.$refs.suggestComponent.input.value = this.registration_jurisdiction
        this.$refs.EnhancedRegistrationJurisdictionRef.$refs.suggestComponent.value = this.registration_jurisdiction
      }

      if (moduleAccountsManagement.vertical_selected != undefined) {
        moduleAccountsManagement.vertical_selected = {}
      }
      if (this.$refs.EnhancedVerticalRef != undefined) {
        this.$refs.EnhancedVerticalRef.$refs.suggestComponent.input.value = this.vertical
        this.$refs.EnhancedVerticalRef.$refs.suggestComponent.value = this.vertical

      }
      if (moduleAccountsManagement.head_office_country_selected != undefined) {
        moduleAccountsManagement.head_office_country_selected = {}
      }
      if (this.$refs.enhanceHeadOfficeCountryRef != undefined) {
        this.$refs.enhanceHeadOfficeCountryRef.$refs.suggestComponent.input.value = this.head_office_country
        this.$refs.enhanceHeadOfficeCountryRef.$refs.suggestComponent.value = this.head_office_country
      }
      this.no_of_employees = data.enh_no_of_employees;
      this.revenue = data.enh_revenue;
      this.currency_code = data.enh_currency_code
      this.company_category = data.enh_company_category;
      this.head_office_address_1 = data.enh_head_office_address_1;
      this.head_office_address_2 = data.enh_head_office_address_2;
      this.head_office_address_3 = data.enh_head_office_address_3;
      this.head_office_city = data.enh_head_office_city;
      this.head_office_county = data.enh_head_office_county;
      this.head_office_country = data.enh_head_office_country;
      this.head_office_postcode = data.enh_head_office_postcode;
      this.registered_office_address_1 = data.enh_registered_office_address_1;
      this.registered_office_address_2 = data.enh_registered_office_address_2;
      this.registered_office_address_3 = data.enh_registered_office_address_3;
      this.registered_office_city = data.enh_registered_office_city;
      this.registered_office_county = data.enh_registered_office_county;
      this.registered_office_postcode = data.enh_registered_office_postcode;

      this.correction_fields_array = []


      if (data.correction_fields != null && data.correction_fields != '') {
this.correction_fields_array = JSON.parse(data.correction_fields)
}









      this.update_id = data.id;
      this.table = data.table;
      this.popupActive = true;
    },
    rejectRemainderAccounts(data) {
      data.table_name = this.table_name;
      console.log(data);
      axios
        .post(
          this.$base_url + "/api/enhanced_accounts/reject_account",
          data
        )
        .then(response => {
          if (response.data.status == "success") {
            this.$vs.notify({
              color: "success",
              title: "Reject Account",
              text: "The account has been successfully rejected"
            });
          }
          this.$refs.remainderAccountsGrid.gridApi.refreshServerSide({purge : true});
        })
        .catch(error => {
          console.log(error);
        });
    },
    rejectedAccounts() {


      this.$router.push({
        name: "enhancedRejectedAccounts",
        params: { table: this.$route.params.table }
      });
    },
    getColumnsFromCSVTable() {
      let self = this;
      let data = {};
      data.table_name = this.table_name;
      axios
        .post(
          this.$base_url + "/api/enhanced_accounts/get_ml_account_columns_from_table",
          data
        )
        .then(response => {



          let result = response.data

            let columns = JSON.parse(result.selected_fields)


            columns.forEach(function(ele,index){

              let label =  null
              let prefix = "enh_";

              if (ele.startsWith(prefix)) {
                  label = ele.slice(prefix.length);
                }

             self.columnDefs.push({
                headerName: label,
                flex:1,
                field: ele,
                filter: "agTextColumnFilter",
                filterParams: {
                  buttons: ["apply", "reset"],
                  maxNumConditions: 4
                }
              });

              self.field_array_columns.push(ele)

              self.selected_fields.push(ele)



            })

            console.log(selected_fields)




          // let result = JSON.parse(response.data);
          // result.forEach(function (ele) {
          //   if (
          //     !ele.column_name.startsWith("ml_") &&
          //     ele.column_name != "canonical_id" &&
          //     ele.column_name != "score" &&
          //     ele.column_name != "accepted" &&
          //     ele.column_name != "added_to_db" &&
          //     ele.column_name != "rejected" &&
          //     ele.column_name.startsWith("enh_") &&
          //     ele.column_name != "enh_id"
          //   ) {
              
          //     self.columnDefs.push({
          //       headerName: ele.column_name,
          //       flex:1,
          //       field: ele.column_name,
          //       filter: "agTextColumnFilter",
          //       filterParams: {
          //         buttons: ["apply", "reset"],
          //         maxNumConditions: 4
          //       }
          //     });
          //   }
            
          // });

          

          
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
  mounted() {
    let self = this
    self.table_name = atob(this.$route.params.table);
    this.getDataSource();
    this.getColumnsFromCSVTable();
    this.getAllPhoneCodes()
  },
  created() {
    var self = this;
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    self.user_id = userInfo["uid"];
    self.user_role = userInfo["userRole"];
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }
    this.getPhoneTypes();
    this.getCurrencyCodes();
  }
};
</script>
<style scoped>

.correction_field_class {
  color: red;
}

.correction_field_input_class {
  border: 1px solid red;
}

.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 5px 5px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}
</style>
